// Version 3, Phase B: Texte der vier Landingpages (Suche und Google Ads). Vertrag: { de: { "<pfad>": { …, faq: [{ q, a }] } }, en: {} }.
// Quellen verdichtet: src/i18n/relaunchSell.js (sell.pages inkl. FAQ), relaunchStock.js, data/industrialAssets.js,
// machineryEquipment.js, surplusInventory.js, plantClosures.js.
// Regeln (Briefing 22.10.2026): Dienstleistungssprache, nie „Parto verkauft“, Ankauf Gefühl erlaubt (Bestand anbieten, Angebot erhalten),
// aber kein Sofortankauf Versprechen. Recycling sparsam, besser Rohstoffrückgewinnung. Partnernetzwerk statt „freigegebene Bestände“.
// Keine Preise, Marktwerte, Anteile oder internen Zeitangaben. Keine Gedankenstriche.
// Englisch folgt später; die Vorlage zeigt bis dahin den deutschen Text.

// Gemeinsame Beschriftungen aller Landingpages
export const LANDING_COMMON = {
    de: {
        stepsTitle: "So läuft es ab",
        stepsText: "Sechs Schritte von Ihrer Entscheidung bis zum Abschluss. Welchen Weg eine Position nimmt, entscheidet ihr Wert.",
        brandsTitle: "Hersteller, die wir regelmäßig aufnehmen",
        brandsNote: "Und viele weitere. Auch gemischte Bestände mit vielen Herstellern sind für uns Routine. Die Herstellernamen dienen nur der Orientierung. Es besteht keine Verbindung zu den Herstellern.",
        trustTitle: "Vertrauen, das Sie prüfen können",
        trustText: "Kundenlogos, Abnehmer im Partnernetzwerk und Kennzahlen zeigen wir hier, sobald sie freigegeben sind.",
        trustClients: "Kunden",
        trustBuyers: "Abnehmer im Partnernetzwerk",
        trustKpis: "Kennzahlen",
        logo: "[Logo]",
        kpi: "[Platzhalter: Kennzahl]",
        kpiLabel: "[Platzhalter: Beschreibung nach Freigabe]",
        trustLine: "Vertrauen von Industrieunternehmen",
        trustNote: "Platzhalter: Logos und Kennzahlen folgen nach Freigabe durch Parto.",
        faqTitle: "Antworten auf Ihre Fragen",
        related: "Auch passend",
    },
};

// Aufbau nach dem Vorbild BuyParto (Wunsch 22.10.2026, siehe tools/qa/BUYPARTO_REFERENZ.md), moderner und im Parto Design.
// Gemeinsame Texte aller vier Landingpages; einzelne Seiten können quick, process und eyebrow überschreiben.
export const LANDING_BP = {
    de: {
        heroEyebrow: "Parto Solution",
        collageAlt: "Industriekomponenten aus Beständen: Servomotor, Ventilinsel, Steuerung und Bedienpanel",
        brandsEyebrow: "Hersteller",
        brandsTitle: "Komponenten aller gängigen Hersteller",
        brandsNote: "Die Herstellernamen dienen nur der Orientierung. Es besteht keine Verbindung zu den Herstellern.",
        quickEyebrow: "In drei Schritten",
        quickTitle: "Einfach anbieten, Parto übernimmt",
        quick: [
            { t: "Liste oder Fotos senden", d: "Eine vorhandene Bestandsliste, ein Export aus Ihrer Warenwirtschaft oder einige Fotos genügen." },
            { t: "Einschätzung erhalten", d: "Parto bewertet jede Position und schlägt Ihnen den passenden Weg vor." },
            { t: "Parto übernimmt", d: "Parto holt ab, findet den passenden Abnehmer im Partnernetzwerk und rechnet je Position ab." },
        ],
        whyEyebrow: "Ihre Vorteile",
        whyTitle: "Warum Parto",
        why: [
            { t: "Persönlich betreut", d: "Ein Ansprechpartner von der Bestandsliste bis zur Abrechnung." },
            { t: "Bewertung je Position", d: "Jede Position wird einzeln eingeschätzt, nicht als Paket unter Wert." },
            { t: "Abholung organisiert Parto", d: "Demontage, Verpackung und Transport organisieren wir für Sie." },
            { t: "Passende Abnehmer", d: "Zugang zu Abnehmern im Partnernetzwerk, auch international." },
            { t: "Nachvollziehbare Abrechnung", d: "Erlös und Nachweise erhalten Sie je Position." },
            { t: "Verantwortungsvoll", d: "Wiederverwendung zuerst, sonst ordnungsgemäße Rohstoffrückgewinnung." },
        ],
        whyImgAlt: "Helles Lager mit Regalen voller Industriekomponenten",
        processEyebrow: "So läuft es ab",
        processTitle: "Jede Position auf ihrem Weg",
        processText: "Sechs Schritte von Ihrer Entscheidung bis zum Abschluss. Welchen Weg eine Position nimmt, entscheidet ihr Wert.",
        // Begriffe identisch mit den Stationen der Grafik „Fluss kompakt“
        process: [
            { t: "Entscheiden", d: "Sie entscheiden, was den Betrieb verlässt. Eine Liste oder Fotos genügen." },
            { t: "Übernehmen", d: "Parto holt ab, verpackt und lagert sicher ein." },
            { t: "Erfassen", d: "Jede Position wird aufgenommen, geprüft und bewertet." },
            { t: "Zuordnen", d: "Jede Position bekommt den passenden Weg, abgestimmt mit Ihnen." },
            { t: "Umsetzen", d: "Parto setzt den Weg um: Direktabnehmer, Ausschreibung im Partnernetzwerk oder Rohstoffrückgewinnung." },
            { t: "Abschließen", d: "Sie erhalten Erlös, Abrechnung und Nachweise je Position." },
        ],
        compareEyebrow: "Im Vergleich",
        compareTitle: "Mit Parto oder selbst organisieren",
        compareCols: ["Mit Parto", "Selbst organisieren"],
        compareRows: [
            { t: "Fester Ansprechpartner", v: ["yes", "no"] },
            { t: "Bewertung je Position", v: ["yes", "part"] },
            { t: "Logistik aus einer Hand", v: ["yes", "no"] },
            { t: "Zugang zu vielen passenden Abnehmern", v: ["yes", "part"] },
            { t: "Abrechnung und Nachweise je Position", v: ["yes", "part"] },
            { t: "Kaum Aufwand für Ihr Team", v: ["yes", "no"] },
        ],
        compareLegend: { yes: "ja", part: "teilweise", no: "nein" },
        compareNote: "Qualitativer Vergleich zur Orientierung.",
        catEyebrow: "Kategorien",
        catTitle: "Komponenten, Maschinen und Anlagen",
        catMore: "Zur Übersicht",
        catAll: "Alle Produkte und Anlagen",
        faqContactTitle: "Ihre Frage ist nicht dabei?",
        faqContactText: "Rufen Sie uns an oder schreiben Sie uns. Wir antworten persönlich.",
        sitEyebrow: "Ihre Situation",
        sitTitle: "Für jede Situation eine Lösung",
        situations: [
            { to: "/solutions/ueberbestaende", t: "Überbestände", d: "Material über dem Bedarf zurück in Kapital und Fläche verwandeln.", img: "/media/parto/lager-voll.jpg" },
            { to: "/solutions/altbestaende-langsamdreher", t: "Altbestände und Langsamdreher", d: "Abgekündigte Teile finden Betriebe, die sie noch brauchen.", img: "/media/parto/komponenten.jpg" },
            { to: "/standortschliessung", t: "Standortschließung und Werksräumung", d: "Hallen zum festen Termin räumen, mit einem klaren Plan.", img: "/media/plant-closures-restructuring-web.jpg" },
            { to: "/solutions/ersatzteile-instandhaltung", t: "Ersatzteile", d: "Gewachsene Ersatzteillager bereinigen, Kritisches bleibt.", img: "/media/parto/kugellager.jpg" },
        ],
        sitMore: "Mehr erfahren",
    },
};

// Herstellernamen als Text (keine Logos ohne Freigabe), aus relaunchSell.js
export const LANDING_BRANDS = ["Siemens", "ABB", "SEW Eurodrive", "Lenze", "Festo", "Beckhoff", "Bosch Rexroth", "Schneider Electric", "Allen Bradley", "Mitsubishi Electric", "Omron", "B&R", "Phoenix Contact", "SICK", "Pepperl+Fuchs", "Danfoss", "Yaskawa", "KUKA", "FANUC", "Heidenhain"];

// Ablauf für Bestände (Komponenten, Überbestand)
const STEPS_STOCK = [
    { t: "Liste oder Fotos senden", d: "Eine Exceldatei, ein Export aus Ihrer Warenwirtschaft oder einige Fotos genügen für den Start." },
    { t: "Bewertung und Empfehlung", d: "Parto prüft Nachfrage und Zustand je Position und empfiehlt den passenden Weg. Sie entscheiden." },
    { t: "Parto übernimmt", d: "Abholung, Lagerung, Aufbereitung und Versand liegen bei uns. Ihr Team wird spürbar entlastet." },
    { t: "Abnehmer und Abrechnung", d: "Ihr Bestand geht an passende Abnehmer im Partnernetzwerk. Sie erhalten eine Abrechnung je Position." },
];

const NO_BUYER = { q: "Was passiert mit Positionen, für die es keinen Abnehmer gibt?", a: "Diese führen wir der Rohstoffrückgewinnung zu, ordnungsgemäß und dokumentiert für Ihre Unterlagen." };
const ANON = { q: "Bleibt unser Unternehmen gegenüber Abnehmern anonym?", a: "Ja. Abnehmer erfahren nicht, von wem die Ware stammt." };

export default {
    de: {
        "/bestaende-verkaufen": {
            productsEyebrow: "Produktgruppen",
            h1: "Industrielle Bestände verkaufen und verwerten",
            sub: "SPS, Antriebe, Ersatzteile oder ein komplettes Lager: Senden Sie uns Ihre Liste oder Fotos. Parto bewertet den Bestand, übernimmt die Abwicklung und bringt jede Position zum passenden Abnehmer.",
            points: [
                "Bewertung je Position statt Paket unter Wert",
                "Abholung, Lagerung und Versand übernimmt Parto",
                "Passende Abnehmer im Partnernetzwerk weltweit",
                "Nachvollziehbare Abrechnung je Position",
            ],
            form: { title: "Bestand anbieten", text: "Liste oder Fotos hochladen, wir melden uns persönlich." },
            steps: STEPS_STOCK,
            productsTitle: "Diese Produkte nehmen wir auf",
            productsText: "Neu, originalverpackt oder gebraucht. Von der einzelnen Baugruppe bis zum ganzen Ersatzteillager.",
            products: [
                { name: "SPS und Steuerungen", desc: "CPUs, Eingabemodule und Ausgabemodule, Kommunikationsbaugruppen." },
                { name: "Frequenzumrichter", desc: "Umrichter, Leistungselektronik und Zubehör." },
                { name: "Servotechnik und Antriebe", desc: "Servomotoren, Servoregler, Motoren, Getriebe." },
                { name: "Bedienpanels", desc: "Touchpanels, Displays und Industrierechner." },
                { name: "Industrieelektronik", desc: "Netzteile, Baugruppen, Steuerungskomponenten." },
                { name: "Sensorik", desc: "Lichtschranken, Näherungsschalter, Messtechnik." },
                { name: "Pneumatik", desc: "Ventile, Ventilinseln, Zylinder." },
                { name: "Ersatzteile", desc: "Instandhaltungsbestand und Reserveteile." },
            ],
            brands: true,
            faq: [
                { q: "Kann ich gebrauchte SPS und Frequenzumrichter anbieten?", a: "Ja. Für die erste Einschätzung helfen Hersteller, Artikelnummer, Menge und nach Möglichkeit der Zustand." },
                { q: "Nehmen Sie auch ganze Lagerbestände auf?", a: "Ja. Von einer einzelnen Produktgruppe bis zum kompletten Ersatzteillager." },
                { q: "Brauche ich eine fertige Bestandsliste?", a: "Nein. Eine Bestandsliste hilft, ist aber keine Voraussetzung. Fehlende Daten erfassen wir bei Bedarf selbst." },
                { q: "Muss die Ware originalverpackt sein?", a: "Nein. Neu, originalverpackt oder gebraucht: Den Zustand bewerten wir je Position." },
                ANON,
                NO_BUYER,
            ],
            sectionForm: { title: "Was sollen wir uns ansehen?", text: "Senden Sie uns Ihre Bestandsliste oder einige Fotos. Wir melden uns persönlich mit dem passenden Weg für Ihren Bestand." },
            related: ["/ueberbestaende-verkaufen", "/maschinen-anlagen-verkaufen", "/standortschliessung"],
        },
        "/ueberbestaende-verkaufen": {
            productsEyebrow: "Typische Anlässe",
            h1: "Überbestände verkaufen",
            sub: "Zu viel bestellt, Projekt beendet, Produkt umgestellt: Parto bringt Ihren Überbestand an den Markt. Sie gewinnen Kapital und Lagerfläche zurück.",
            points: [
                "Kapital und Lagerfläche zurückgewinnen",
                "Bewertung je Position statt Paket unter Wert",
                "Kaum Aufwand für Ihr Team",
                "Nachvollziehbare Abrechnung je Position",
            ],
            form: { title: "Überbestand anbieten", text: "Liste oder Fotos hochladen, wir melden uns persönlich." },
            steps: STEPS_STOCK,
            productsTitle: "Wie Überbestand entsteht",
            productsText: "Fast jedes Werk kennt diese Situationen. Für jede gibt es einen passenden Weg.",
            products: [
                { name: "Zu große Bestellungen", desc: "Wegen Mindestmengen und Mengenrabatten wurde mehr bestellt als benötigt." },
                { name: "Beendete Projekte", desc: "Material aus Projekten, die abgeschlossen oder gestoppt wurden." },
                { name: "Produktumstellung", desc: "Teile für ein Produkt, das nicht mehr gefertigt wird." },
                { name: "Sicherheitsbestand", desc: "Reserven, die über Jahre gewachsen sind und nicht mehr gebraucht werden." },
                { name: "Gemischte Bestände", desc: "Kleine Mengen vieler verschiedener Artikel." },
                { name: "Mehrere Standorte", desc: "Überbestand, der verteilt in mehreren Lagern liegt." },
            ],
            brands: true,
            faq: [
                { q: "Kann ich Überbestand über Parto anbieten?", a: "Ja. Wir prüfen Ihren Bestand und empfehlen für jede Position den passenden Weg." },
                { q: "Welche Mengen sind sinnvoll?", a: "Von einer Produktgruppe bis zu großen Lagern an mehreren Standorten." },
                { q: "Kann ich meine Bestandsliste einfach als Exceldatei senden?", a: "Ja. Hilfreich sind Hersteller, Artikelnummer, Bezeichnung, Menge, Zustand und Standort." },
                { q: "Entscheide ich, was das Lager verlässt?", a: "Ja. Kritische Teile bleiben bei Ihnen. Nur was Sie bestimmen, geht ins Partnernetzwerk." },
                ANON,
                NO_BUYER,
            ],
            sectionForm: { title: "Wieder Platz im Lager schaffen", text: "Senden Sie uns Ihre Bestandsliste. Wir melden uns persönlich mit einer Einschätzung für Ihren Überbestand." },
            related: ["/bestaende-verkaufen", "/maschinen-anlagen-verkaufen", "/standortschliessung"],
        },
        "/maschinen-anlagen-verkaufen": {
            productsEyebrow: "Maschinen und Anlagen",
            collageAlt: "Industriemaschinen und Baugruppen: Maschine in der Fertigung, Getriebe, Maschinenpark und Elektromotor",
            h1: "Maschinen und Anlagen verkaufen",
            quick: [
                { t: "Fotos und Typenschild senden", d: "Gesamtansicht, Typenschild und Steuerung genügen für den Start." },
                { t: "Einschätzung erhalten", d: "Parto bewertet die Maschine und schlägt den passenden Weg vor." },
                { t: "Parto übernimmt", d: "Abbau, Abtransport, Abnehmer und Abrechnung aus einer Hand." },
            ],
            sub: "Einzelmaschine, komplette Linie oder Maschinenersatzteile: Parto bewertet, findet passende Abnehmer und organisiert Abbau und Abtransport.",
            points: [
                "Maschine, Ersatzteile und Logistik aus einer Hand",
                "Abbau und Abtransport nach Ihrem Zeitplan",
                "Passende Abnehmer im Partnernetzwerk",
                "Auch stillgelegte oder defekte Maschinen haben Wert",
            ],
            form: { title: "Maschinen anbieten", text: "Fotos der Maschine und des Typenschilds reichen uns für den Anfang." },
            steps: [
                { t: "Fotos und Daten senden", d: "Gesamtansicht, Typenschild, Steuerung. Dazu Baujahr und Zustand, soweit bekannt." },
                { t: "Bewertung und Empfehlung", d: "Parto bewertet die Maschine und empfiehlt den passenden Weg. Sie entscheiden." },
                { t: "Abnehmer finden", d: "Parto bringt die Maschine an den Markt: direkt an Betriebe, über Fachhändler oder in einer Ausschreibung." },
                { t: "Abbau und Abrechnung", d: "Demontage, Verladung und Abtransport organisieren wir. Sie erhalten eine saubere Abrechnung." },
            ],
            productsTitle: "Das nehmen wir auf",
            productsText: "Laufend, stillgelegt oder defekt. Als ganze Maschine oder in Baugruppen.",
            products: [
                { name: "Einzelne Maschinen", desc: "Werkzeugmaschinen, Pressen, Verpackungsmaschinen und mehr." },
                { name: "Komplette Linien", desc: "Produktionslinien und Anlagen, ganz oder in Teilen." },
                { name: "Aggregate und Baugruppen", desc: "Pumpen, Kompressoren, Getriebe, Antriebseinheiten." },
                { name: "Maschinenersatzteile", desc: "Reserveteile, auch ohne die zugehörige Maschine." },
                { name: "Steuerung und Elektrik", desc: "Schaltschränke, Steuerungen und Bedienpanels." },
                { name: "Betriebsmittel", desc: "Regale, Werkzeuge, Hebezeuge und Ausstattung." },
            ],
            brands: false,
            faq: [
                { q: "Kann ich gebrauchte Maschinen über Parto anbieten?", a: "Ja. Wir prüfen jede Maschine einzeln: Zustand, Dokumentation, Standort und Nachfrage." },
                { q: "Kann ich auch nur Ersatzteile anbieten?", a: "Ja. Ersatzteile prüfen wir einzeln oder zusammen mit der Maschine." },
                { q: "Welche Angaben braucht Parto?", a: "Hersteller, Typ, Baujahr, Zustand und Standort. Dazu Fotos und vorhandene Unterlagen." },
                { q: "Welche Fotos sind hilfreich?", a: "Eine Gesamtansicht, das Typenschild, die Steuerung und wichtige Baugruppen." },
                { q: "Muss die Maschine noch laufen?", a: "Nein. Auch defekte Maschinen haben einen Wert, etwa als Ersatzteilspender." },
                { q: "Übernimmt Parto den Abbau?", a: "Ja, auf Wunsch. Demontage, Verladung und Abtransport organisieren wir nach Ihrem Zeitplan." },
            ],
            sectionForm: { title: "Maschine oder Anlage abzugeben?", text: "Senden Sie uns Fotos und das Typenschild. Wir melden uns persönlich mit einer Einschätzung." },
            related: ["/bestaende-verkaufen", "/ueberbestaende-verkaufen", "/standortschliessung"],
        },
        "/standortschliessung": {
            productsEyebrow: "Umfang",
            collageAlt: "Werkhalle bei einer Räumung: leere Halle, Paletten, geräumtes Lager und Verladung mit dem Stapler",
            h1: "Standortschließung und Werksräumung aus einer Hand",
            quick: [
                { t: "Vorhaben beschreiben", d: "Standort, Umfang und Termin kurz beschreiben, gern mit Fotos oder Listen." },
                { t: "Plan erhalten", d: "Parto begeht den Standort mit Ihnen und plant nach Hallen und Termin." },
                { t: "Parto übernimmt", d: "Erfassung, Abtransport, Abnehmer und Abrechnung aus einer Hand." },
            ],
            process: [
                { t: "Entscheiden", d: "Sie legen fest, was den Standort verlässt und was bleibt." },
                { t: "Übernehmen", d: "Parto baut vor Ort ab und transportiert zum vereinbarten Termin." },
                { t: "Erfassen", d: "Maschinen, Anlagen und Material werden aufgenommen, geprüft und bewertet." },
                { t: "Zuordnen", d: "Behalten, ins Partnernetzwerk geben oder der Rohstoffrückgewinnung zuführen. Sie entscheiden." },
                { t: "Umsetzen", d: "Parto bringt jede Position zum passenden Abnehmer." },
                { t: "Abschließen", d: "Übergabe der Hallen zum Termin, Abrechnung je Position." },
            ],
            sub: "Schließung, Verlagerung oder Umbau: Parto erfasst alles, was den Standort verlassen soll, findet passende Abnehmer und übergibt die Hallen zum vereinbarten Termin.",
            points: [
                "Ein Plan, der zum Übergabetermin passt",
                "Alle Hallen und Wege in einem Plan",
                "Ihr Team bleibt frei für Umzug und Tagesgeschäft",
                "Lückenlos dokumentiert bis zur Abrechnung",
            ],
            form: { title: "Projekt anfragen", text: "Standort und Umfang kurz beschreiben, gern mit Fotos." },
            steps: [
                { t: "Umfang festlegen", d: "Wir begehen den Standort mit Ihnen und planen nach Hallen, Umfang und Termin." },
                { t: "Erfassen", d: "Jedes Teil wird vor Ort mit Foto und Typenschild aufgenommen." },
                { t: "Wege entscheiden", d: "Behalten, ins Partnernetzwerk geben oder der Rohstoffrückgewinnung zuführen. Sie entscheiden." },
                { t: "Räumen und abrechnen", d: "Abtransport, Übergabe an die Abnehmer und Abrechnung im vereinbarten Zeitplan." },
            ],
            productsTitle: "Was bei einer Räumung anfällt",
            productsText: "Alles, was den Standort verlassen soll, in einem gemeinsamen Räumungsplan.",
            products: [
                { name: "Maschinen und Anlagen", desc: "Produktionsanlagen, Linien und Einzelmaschinen." },
                { name: "Ersatzteillager", desc: "Reserveteile und Instandhaltungsbestand." },
                { name: "Material und Halbzeuge", desc: "Rohmaterial, Vorprodukte und Restbestände." },
                { name: "Betriebsmittel", desc: "Regale, Werkzeuge, Hebezeuge, Büroausstattung." },
                { name: "Teile für andere Werke", desc: "Was weiter gebraucht wird, sichern wir und liefern es an Ihre anderen Standorte." },
                { name: "Rohstoffrückgewinnung", desc: "Was keinen Abnehmer findet, geht dokumentiert in die ordnungsgemäße Rohstoffrückgewinnung." },
            ],
            brands: false,
            faq: [
                { q: "Übernimmt Parto komplette Standortschließungen?", a: "Ja. Parto übernimmt alles, was den Standort verlassen soll, von der Erfassung bis zur Übergabe der Hallen." },
                { q: "Brauche ich eine vollständige Bestandsliste?", a: "Nein. Was fehlt, erfassen wir vor Ort." },
                { q: "Kann Parto direkt am Standort erfassen?", a: "Ja. Je nach Umfang erfassen wir vor Ort oder nach der Übernahme in unserem Lager." },
                { q: "Geht das auch an mehreren Standorten?", a: "Ja. Dann legen wir ein einheitliches Vorgehen fest, das an jedem Standort gleich abläuft." },
                { q: "Kümmert sich Parto auch um den Abtransport?", a: "Ja, auf Wunsch. Logistik und Übergabe können Teil des Auftrags sein." },
                { q: "Was ist mit Teilen, die wir weiter brauchen?", a: "Diese bleiben bei Ihnen. Was den Standort nicht verlässt, legen Sie zu Beginn fest." },
            ],
            sectionForm: { title: "Standort mit festem Termin räumen", text: "Erzählen Sie uns von Ihrem Vorhaben. Wir melden uns persönlich und planen den Umfang mit Ihnen." },
            related: ["/maschinen-anlagen-verkaufen", "/bestaende-verkaufen", "/ueberbestaende-verkaufen"],
        },
    },
    en: {},
};
